import React, { PureComponent } from "react";

class LabelPortfolio extends PureComponent {

    render() {

      const { tarjetas } = this.props;
      const empresaSeleccionada = tarjetas.empresas.find(x => x.seleccionada);
      let carteraId = empresaSeleccionada.CarteraId;
      let cartera;

      if (empresaSeleccionada.esNueva) {
            carteraId = empresaSeleccionada.cartera.id;
      }

      if (empresaSeleccionada) {
        cartera = tarjetas.carteras.find(x => x.Id == carteraId)
        if (cartera) {
          cartera = <div className="col-xs-12" >
             <label className="label-primary">{cartera.Codigo + " - " + cartera.Descripcion}</label>
             </div>;
        } else {
          cartera = <div className="col-xs-12">
              <label className="label-secondary">
                 Por favor seleccione el producto al inicio del formulario
              </label>
          </div>
         }
      }

      return (
      <div className="bottom-separator-xs">
         <div className="row">
            <div className="col-xs-12">
                <label className="label-primary">Cartera</label>
             </div>
         </div>
         <div className="row">
            {cartera}
          </div>
      </div>
      );

    }
}

export default LabelPortfolio;